var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIco44GradeSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "81.119%",
    y1: "22.827%",
    x2: "24.824%",
    y2: "85.297%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE5FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD2EF",
    offset: "53.213%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDC1E0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.052%",
    y1: "24.867%",
    x2: "90.525%",
    y2: "74.256%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D4F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12%",
    y1: "18.257%",
    x2: "91.527%",
    y2: "67.647%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF",
    offset: "62.816%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6DFF6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.769%",
    y1: "114.529%",
    x2: "52.769%",
    y2: "44.447%",
    id: "h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEEF7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-11.2%",
    y: "-11.2%",
    width: "122.5%",
    height: "122.5%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.665561294 0 0 0 0 0.68902774 0 0 0 0 0.76588064 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-25.9%",
    y: "-18.6%",
    width: "151.7%",
    height: "137.2%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: 0.2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.767013979 0 0 0 0 0.801311002 0 0 0 0 0.912228792 0 0 0 0.0991262156 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.448231479 0 0 0 0 0.480597321 0 0 0 0 0.647019096 0 0 0 0.5 0",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-60.8%",
    y: "-43.4%",
    width: "221.6%",
    height: "186.8%",
    filterUnits: "objectBoundingBox",
    id: "i"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.70690445 0 0 0 0 0.71726989 0 0 0 0 0.771548064 0 0 0 0.5 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.762 1.051C6.47 2.191 6.275 3.807 6.42 5.192l.02.172.023.17.025.166.029.163.03.159.033.155.052.225.035.144.055.207.074.257.073.232.083.252.156.444.034.116.016.058.028.119c.233 1.05-.023 2.216-1.374 2.114-.678-.052-1.083-.893-1.232-1.446-.252-.935-1.615-1.184-2.276-.423C-.928 12.2-1.27 19.416 4.611 23.062c3.082 1.91 9.536 2.029 12.305-4.752.922-2.571.425-4.775-.77-6.935l-.132-.236a16.511 16.511 0 0 0-.21-.353l-.146-.235-.15-.235-.156-.235a23.13 23.13 0 0 0-.08-.118l-.16-.235-.167-.236-.17-.236-.173-.237-.177-.237-.18-.238-.183-.239-.28-.36-.285-.362-.29-.364-.996-1.239c-1.515-1.888-1.524-3.372-1.076-4.432.387-.915-.606-1.825-1.64-1.469-.67.232-1.207.534-1.632.886l-.1.086z",
    id: "g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73 13.575c-.556.49-1.677 2.326-1.957 2.757-1.208 1.864-1.536 4.702.991 6.268 1.325.822 4.099.872 5.289-2.042.396-1.105.182-2.052-.331-2.98l-.057-.101-.09-.152-.063-.101a8.515 8.515 0 0 0-.065-.101l-.066-.101a9.937 9.937 0 0 0-.034-.05l-.07-.102-.071-.101-.073-.102-.075-.101-.076-.102-.077-.103-.079-.102-.12-.155-.123-.156-.125-.156-.427-.533c-.651-.81-.435-1.446-.434-1.966 0-.519-.524-.675-.967-.522-.193.067-.493.335-.9.804z",
    id: "j"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 22 20)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 4C11.163 4 4 11.163 4 20s7.163 16 16 16 16-7.163 16-16S28.837 4 20 4z",
    fill: "url(#d)",
    fillRule: "nonzero",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm0 3C10.611 3 3 10.611 3 20s7.611 17 17 17 17-7.611 17-17S29.389 3 20 3z",
    fill: "url(#e)",
    fillRule: "nonzero",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 30.697 9.905)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#h)",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.582 9.905)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#j"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco44GradeSilver);
export default __webpack_public_path__ + "static/media/ico_44_grade_silver.159a35af.svg";
export { ForwardRef as ReactComponent };